import { auth } from "./config";

import { isSignInWithEmailLink as fbIsSignInWithEmailLink } from "firebase/auth";

const isSignInWithEmailLink = () => {
  return fbIsSignInWithEmailLink(auth, window.location.href);
};

export default isSignInWithEmailLink;
